import { STATUS_LABELS, PAYMENT_STATUS_LABELS } from "../../lib/orderLabels";

const selectCls =
    "px-3 py-2 rounded-xl border-2 border-[var(--border-subtle)] bg-white text-sm font-bold text-text-main focus:outline-none focus:border-brand";

export default function OrderFilters({ filters, setFilters }) {
    const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
    return (
        <div className="surface-card p-3 mb-4 space-y-3" data-testid="owner-filters">
            <div className="relative">
                <i className="fa-solid fa-magnifying-glass absolute top-1/2 -translate-y-1/2 right-3 text-text-muted" />
                <input
                    value={filters.q}
                    onChange={(e) => set("q", e.target.value)}
                    data-testid="owner-search"
                    placeholder="ابحث برقم الطلب أو اسم العميل أو الجوال"
                    className="w-full pr-9 pl-3 py-2.5 rounded-xl border-2 border-[var(--border-subtle)] bg-[var(--bg)] text-sm focus:outline-none focus:border-brand"
                />
            </div>
            <div className="flex gap-2 overflow-x-auto no-scrollbar">
                {[["all", "الكل"], ...Object.entries(STATUS_LABELS)].map(([key, label]) => (
                    <button
                        key={key}
                        onClick={() => set("status", key)}
                        data-testid={`owner-filter-status-${key}`}
                        className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm font-bold transition ${
                            filters.status === key
                                ? "bg-brand text-white"
                                : "bg-white border border-[var(--border-subtle)] text-text-muted"
                        }`}
                    >
                        {label}
                    </button>
                ))}
            </div>
            <div className="flex flex-wrap gap-2">
                <select
                    value={filters.payment_status}
                    onChange={(e) => set("payment_status", e.target.value)}
                    data-testid="owner-filter-payment"
                    className={selectCls}
                >
                    <option value="all">كل حالات الدفع</option>
                    {Object.entries(PAYMENT_STATUS_LABELS).map(([k, l]) => (
                        <option key={k} value={k}>{l}</option>
                    ))}
                </select>
                <select
                    value={filters.order_type}
                    onChange={(e) => set("order_type", e.target.value)}
                    data-testid="owner-filter-type"
                    className={selectCls}
                >
                    <option value="all">كل أنواع التوصيل</option>
                    <option value="car">توصيل للسيارة</option>
                    <option value="location">توصيل للموقع</option>
                </select>
            </div>
        </div>
    );
}
